/**
 * 用户管理API配置
 * lixian
 */
const api = [
  {
    name: 'userList',
    method: 'GET',
    desc: '用户列表',
    path: '/findUserByName',
    mock: false,
    params: {
      pageNum: 1,
      pageSize: 25
    }
  },
  {
    name: 'salesList',
    method: 'GET',
    desc: '员工列表',
    path: '/findSalesman',
    mock: false,
    params: {
      pageNum: 1,
      pageSize: 25
    }
  },
  {
    name: 'addUser',
    method: 'POST',
    desc: '添加用户',
    path: '/addUser',
    mock: false,
    params: {}
  },
  {
    name: 'changeEnable',
    method: 'POST',
    desc: '更改用户启用状态',
    path: '/changeEnable',
    mock: false,
    params: {}
  },
  {
    name: 'deleteUser',
    method: 'GET',
    desc: '删除用户',
    path: '/deleteUser',
    mock: false,
    append: true,
    params: {}
  },
  {
    name: 'editUser',
    method: 'POST',
    desc: '编辑用户',
    path: '/editUser',
    mock: false,
    params: {}
  },
  {
    name: 'getSysRole',
    method: 'GET',
    desc: '获取用户角色',
    path: '/getSysRole',
    mock: false,
    params: {}
  },
  {
    name: 'getMobileIsExist',
    method: 'GET',
    desc: '检测手机号码是否存在',
    path: '/getMobileIsExist',
    mock: false,
    append: true,
    params: {}
  },
  {
    name: 'getUserNameIsExist',
    method: 'GET',
    desc: '用户是否存在',
    path: '/getUserNameIsExist',
    mock: false,
    append: true,
    params: {}
  },
  {
    name: 'resetPassWord',
    method: 'POST',
    desc: '重置密码',
    path: '/resetPassWord',
    mock: false,
    params: {}
  },
  {
    name: 'getSalesman',
    method: 'GET',
    desc: '获取业务员列表',
    path: '/getSalesman',
    mock: false,
    params: {}
  },
  {
    name: 'all',
    method: 'GET',
    desc: '获取所有员工',
    path: '/all'
  }
]

export default {
  BASE_URL: '/sysUser',
  NAMESPACE: 'user',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/sys/user.js